<!--
 * @Author: suhe@hikvison.com.cn
 * @Date: 2019-11-14 09:10:39
 * @LastEditors: dongwenjuan@hikvison.com.cn
 * @LastEditTime: 2024-08-22 16:29:20
 -->
<template>
  <div class="step-container step4">
    <i class="iconfont icon-member_sel-copy-copy"></i>
    <p class="success-p">恭喜你，密码修改成功</p>
    <p class="skip-p">{{ timer }}s之后自动跳转到登录页&nbsp;<a @click="goHome">立即跳转</a></p>
  </div>
</template>
<script>

import _ from "../../utils/index.js";

export default {
  data() {
    return {
      timer: 3
    };
  },
  methods: {
    gotoHome() {
      window.timer = setInterval(() => {
        this.timer--;
        if (!this.timer) {
          clearInterval(window.timer);
          window.timer = null;
          // eslint-disable-next-line eqeqeq
          if (this.$route.query.type == 'auth') {
            const query = JSON.parse(JSON.stringify(this.$route.query));
            const queryStr = _.parseQuery(query);
            this.$router.push("/auth/login" + queryStr);
          } else if (this.$route.query.type === "drainage") {
            const url = decodeURIComponent(this.$route.query.redirect_uri);
            location.href = url;
          } else {
            this.$router.push("/login");
          }
        }
      }, 1000);
    },
    goHome() {
      // eslint-disable-next-line eqeqeq
      if (this.$route.query.type == 'auth') {
        const query = JSON.parse(JSON.stringify(this.$route.query));
        const queryStr = _.parseQuery(query);
        this.$router.push("/auth/login" + queryStr);
      } else if (this.$route.query.type === "drainage") {
        const url = decodeURIComponent(this.$route.query.redirect_uri);
        location.href = url;
      } else {
        this.$router.push("/login");
      }
    }
  },
  mounted() {
    this.gotoHome();
  }
};
</script>
<style lang="less" scoped>
.step-container {
  padding-top: 40px;
  padding-bottom: 100px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &.step4 {
    padding-right: 0px;
    flex-direction: column;
    align-items: center;
  }
  .icon-member_sel-copy-copy {
    font-size: 60px;
    display: block;
    color: #09bb07;
    margin-bottom: 20px;
  }
  .skip-p {
    color: #999999;
    font-size: 14px;
    line-height: 40px;
    a {
      font-size: 14px;
      color: #6589ff;
      line-height: 24px;
    }
  }
  .success-p {
    color: #666666;
    font-size: 18px;
  }
}
</style>
